import { ChangeDetectionStrategy, Component, EventEmitter, inject, Output } from '@angular/core';
import { MatDialog, MatDialogModule } from '@angular/material/dialog';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';
import { MathEquationDialogComponent } from '../math-equation-dialog/math-equation-dialog.component';

@Component({
  selector: 'app-add-math-equation-option',
  standalone: true,
  imports: [TranslateModule, MatIconModule, MatDialogModule],
  template: `
    <div class="interactive-item" (click)="onClick()">
      <div class="interactive-item__content">
        <mat-icon class="interactive-item__icon" aria-hidden="true">functions</mat-icon>
        <span class="interactive-item__text">{{ 'CreateChunk.MathExpression' | translate }}</span>
      </div>
    </div>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AddMathEquationOptionComponent {
  @Output() actionTriggered = new EventEmitter<string>();

  private dialog = inject(MatDialog);

  onClick(): void {
    const dialogRef = this.dialog.open(MathEquationDialogComponent, {
      width: '90vw',
      maxWidth: '600px',
    });

    dialogRef.afterClosed().subscribe((latexCode) => {
      if (latexCode) {
        this.actionTriggered.emit(latexCode);
      }
    });
  }
}
